import apiClient from '../axios';

// Interfaces
export interface ApiResponse<T> {
  responseValue: T;
  statusCode: number;
  message: string;
}

export interface Tender {
  id: number;
  slug: string;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  status: number;
  version?: number;
  branchId?: number;
  categoryId?: number;
  regionId?: number;
  createdDate: string;
  updatedDate?: string;
  companyId?: number;
  companyName?: string;
  totalProducts?: number;
  estimatedValue?: number;
  // Added fields commonly present in detailed tender responses
  isVoted?: boolean;
}

export interface GetAllTendersWithPaginationRequest {
  PageNumber?: number;
  PageSize?: number;
  SearchTerm?: string;
  BranchIds?: number[];
  StartDate?: string;
  EndDate?: string;
  CategoryIds?: number[];
  RegionIds?: number[];
  Status?: number;
}

export interface PaginatedTendersResponse {
  items: Tender[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface GetTenderByIdOrSlugRequest {
  Id?: number;
  Slug?: string;
  Version?: number;
}

export interface GetTenderByIdOrSlugResponse extends Tender {}

export const tenderService = {
  // Get all tenders with pagination
  async getAllTendersWithPagination(data: GetAllTendersWithPaginationRequest): Promise<ApiResponse<PaginatedTendersResponse>> {
    const params = new URLSearchParams();
    
    if (data.PageNumber !== undefined) params.append('PageNumber', data.PageNumber.toString());
    if (data.PageSize !== undefined) params.append('PageSize', data.PageSize.toString());
    if (data.SearchTerm) params.append('SearchTerm', data.SearchTerm);
    if (data.StartDate) params.append('StartDate', data.StartDate);
    if (data.EndDate) params.append('EndDate', data.EndDate);
    
    if (data.BranchIds && data.BranchIds.length > 0) {
      data.BranchIds.forEach(id => params.append('BranchIds', id.toString()));
    }
    
    if (data.CategoryIds && data.CategoryIds.length > 0) {
      data.CategoryIds.forEach(id => params.append('CategoryIds', id.toString()));
    }
    
    if (data.RegionIds && data.RegionIds.length > 0) {
      data.RegionIds.forEach(id => params.append('RegionIds', id.toString()));
    }
    
    if (data.Status !== undefined) {
      params.append('Status', data.Status.toString());
    }

    const response = await apiClient.get('/Tenders/web/get-all-with-pagination', {
      params
    });
    
    return response.data;
  },

  // Get tender by ID or slug
  async getTenderByIdOrSlug(data: GetTenderByIdOrSlugRequest): Promise<ApiResponse<GetTenderByIdOrSlugResponse>> {
    const params = new URLSearchParams();
    
    if (data.Id !== undefined) params.append('Id', data.Id.toString());
    if (data.Slug) params.append('Slug', data.Slug);
    if (data.Version !== undefined) params.append('Version', data.Version.toString());

    const response = await apiClient.get('/Tenders/web/get-by-id-or-slug', {
      params
    });
    
    return response.data;
  }
};

export default tenderService;
